module.exports = __webpack_public_path__ + "node_modules/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-256.gif";


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/AwesomeLoader/loader-256.gif
// module id = 1149
// module chunks = 0